export const DEPENDENCY = 'dependency';
